import { colors, screen } from 'components/styles/variables';

const ProgressBar = ({
  currentStep,
  totalSteps,
}: {
  currentStep: number;
  totalSteps: number;
}): JSX.Element => {
  return (
    <>
      <div className="progress-bar">
        <div className="progress-indicator" />
      </div>
      <style jsx>{`
        @media screen and (max-width: ${screen.mobileMax}) {
          .progress-bar {
            width: 100%;
            height: 4px;
            background: ${colors.G2};
            position: relative;
          }
        }
        .progress-indicator {
          border-radius: 0;
        }
        @media screen and (min-width: ${screen.xsMin}) {
          .progress-bar {
            width: 400px;
            height: 4px;
            background: ${colors.G2};
            position: relative;
            top: 24px;
          }
          .progress-indicator {
            border-radius: 100px;
          }
        }
        .progress-indicator {
          height: 100%;
          width: ${(100 / totalSteps) * currentStep}%;
          background: ${colors.ALR1};
        }
      `}</style>
    </>
  );
};

export default ProgressBar;
